import QuantityButtons from 'components/common/QuantityButtons';
import { currencyFormat } from 'helpers/utils';
import React from 'react';
import IMerchProduct from 'models/restful/IMerchProduct';
import IMerchProductOrderItem from 'models/restful/IMerchProductOrderItem';

interface IDesignPricingProps {
  product: IMerchProduct | undefined;
  orderItem: IMerchProductOrderItem;
  onQuantityChange: (quantity: number) => void;
  disabled?: boolean;
}

const DesignPricing: React.FC<IDesignPricingProps> = ({
  product,
  orderItem,
  onQuantityChange,
  disabled
}) => (
  <div className="design-card__pricing">
    <div className="pricing-section">
      <div className="pricing-section__details">
        <div className="pricing-section__row">
          <div className="pricing-section__item">
            <label htmlFor="price">Unit Price</label>
            <div className="pricing-section__price">
              {currencyFormat(product?.FixedPrice ?? 0, {
                minimumFractionDigits: 2
              })}
            </div>
          </div>

          <div className="pricing-section__item" style={{ flex: 1 }}>
            <label htmlFor="quantity">Quantity</label>
            <QuantityButtons
              quantity={orderItem.Quantity}
              setQuantity={(quantity: number) => {
                if (quantity > 0) {
                  onQuantityChange(quantity);
                }
              }}
              disabled={disabled}
              inputProps={{
                min: 1,
                onKeyDown: event => {
                  // Allow digits, delete, backspace, and arrow keys
                  if (
                    !/^\d$/.test(event.key) &&
                    ![
                      'Delete',
                      'Backspace',
                      'ArrowLeft',
                      'ArrowRight'
                    ].includes(event.key)
                  ) {
                    event.preventDefault();
                  }
                }
              }}
            />
          </div>

          <div className="pricing-section__item">
            <label>Total</label>
            <div className="pricing-section__price pricing-section__price--total">
              {currencyFormat(orderItem.PriceAmount, {
                minimumFractionDigits: 2
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DesignPricing;
